import { DropdownButton } from "@vega-core/components/Buttons/DropdownButton/DropdownButton";
import { type ThemedButtonProps } from "@vega-core/components/Buttons/ThemedButton";
import { cnTwMerge } from "@vega-core/utils/cnTwMerge";

type DropdownTriggerProps = ThemedButtonProps & {
  placeholder: string;
  selectedCount: number;
  isOpen: boolean;
  onOpenChange: (isOpen: boolean) => void;
};

export const DropdownTrigger = ({
  placeholder,
  selectedCount,
  isOpen,
  onOpenChange,
  disabled,
  className,
  ...props
}: DropdownTriggerProps) => (
  <DropdownButton
    {...props}
    as="div"
    className={cnTwMerge(
      "flex justify-between body-base-medium text-text/primary",
      className,
    )}
    disabled={disabled}
    onClick={disabled ? undefined : () => onOpenChange(!isOpen)}
    open={isOpen}
  >
    <div className="w-full flex justify-between">
      <div className="flex gap-2 items-center">
        <div>{placeholder}</div>
        {selectedCount >= 0 && (
          <div className="min-w-4.5 ml-2">
            {selectedCount > 0 && (
              <span className="flex items-center justify-center h-4.5 min-w-4.5 px-1 py-0.5 bg-text/interactive rounded-small">
                <p className="body-small-semibold text-background/primary">
                  {selectedCount}
                </p>
              </span>
            )}
          </div>
        )}
      </div>
    </div>
  </DropdownButton>
);
